require('./ProgramSubtitle.scss');

const b = require('app/www/libs/b')('program-subtitle');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Link = require('app/www/components/blocks/Link/Link');

class ProgramSubtitle extends React.PureComponent {

    render() {
        const {i18n, text, link} = this.props;

        const linkProps = link && {
            url: link.url,
            mods: {
                external: 'text',
            },
            attrs: {
                target: '_blank',
            },
        };

        return (
            <h3 className={b()}>
                {text}
                {link && (
                    <Link className={b('more')} {...linkProps}>
                        {link.text || i18n.get('program-subtitle.more')}
                    </Link>
                )}
            </h3>
        );
    }
}

ProgramSubtitle.propTypes = {
    text: PropTypes.string,
    link: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.shape({
            text: PropTypes.string,
            url: PropTypes.string,
        }),
    ]),
};

module.exports = withI18n(ProgramSubtitle);
